// extracted by css-extract-rspack-plugin
export default {"cls1":"Banner-cls1_s1V","cls2":"Banner-cls2_66w Banner-cls1_s1V"};